
import BlogPostsCarousel from '~/components/blog/BlogPostsCarousel.vue'
export default {
  name: 'BlogPostListSlice',
  props: ['slice'],
  components: { BlogPostsCarousel },
  data() {
    return {
      id: this.slice.id.replace('$',''),
      posts: []
    }
  },
  async fetch() {
    try {
      const lang = this.$i18n.locales.filter((i) => i.iso.includes(this.$i18n.locale))[0].iso
      const categoryId = this.slice.primary.category.id
      const limit = this.slice.primary.limit
      const response = await this.$prismic.api.query(this.$prismic.predicates.at(`my.post.category`, categoryId), { lang, pageSize: limit || 6, fetchLinks: 'blog_category.name' })
      this.posts = response.results
    } catch (e) {
      error({ message:  JSON.stringify(e), statusCode: 404 })
    }
  }
}
